import { motion } from "framer-motion";

export const IntroducingLizSection = () => {
  return (
    <section
      id="introducing-liz"
      className="py-12 lg:py-16"
      data-testid="introducing-liz-section"
    >
      <div className="flex flex-col lg:flex-row h-[605px]">
        {/* Left - Image (1/2) */}
        <div className="lg:w-1/2 relative h-full bg-white">
          <img 
            src="https://customer-assets.emergentagent.com/job_spreadsheet-portal-4/artifacts/qe5s1b3f_1727021728262.jpg"
            alt="Liz Son"
            className="w-full h-[605px] object-contain"
            data-testid="liz-image"
          />
        </div>

        {/* Right - Text with matching background */}
        <div className="lg:w-1/2 bg-white flex items-center justify-start pl-[5%] pr-8 h-[605px]">
          <div className="w-full flex flex-col items-center justify-center text-center max-w-[400px]">
            {/* Section Title */}
            <motion.div
              initial={{ opacity: 0, y: 15 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: false, amount: 0.5 }}
              transition={{ duration: 0.4 }}
              className="mb-4"
            >
              <span className="text-gold-500 font-medium text-sm tracking-wider uppercase block">
                Introducing
              </span>
              <span className="text-stone-800 font-bold text-3xl md:text-4xl block mt-2">
                Liz Son
              </span>
              <span className="text-gold-500 font-medium text-sm tracking-wider block mt-1">
                Founder & CEO
              </span>
            </motion.div>
            
            <motion.div
              initial={{ opacity: 0, y: 15 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: false, amount: 0.5 }}
              transition={{ duration: 0.4, delay: 0.1 }}
              className="mb-10"
            >
              <p className="text-stone-600 text-xl md:text-2xl font-medium italic">
                중년들이 자유롭고 당당하게
              </p>
              <p className="text-stone-600 text-xl md:text-2xl font-medium italic">
                연애하는 세상,
              </p>
              <p className="text-stone-600 text-xl md:text-2xl font-medium italic">
                리즈가 만들어 갑니다.
              </p>
            </motion.div>
            
            {/* Main Content */}
            <div className="space-y-6 max-w-[400px]">
              <motion.div
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: false, amount: 0.5 }}
                transition={{ duration: 0.5, delay: 0.15 }}
              >
                <motion.h3
                  className="text-burgundy-500 font-bold text-xl mb-2"
                  whileHover={{ scale: 1.05, x: 8 }}
                  transition={{ type: "spring", stiffness: 300 }}
                >
                  사랑 큐레이터
                </motion.h3>
                <p className="text-stone-600 text-base leading-relaxed">
                  사람을 이어주는 역할을 넘어, 사랑의 진정한 의미를 깨닫고 올바른 관계의 기준을 세워드립니다.
                </p>
              </motion.div>
              
              <motion.div
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: false, amount: 0.5 }}
                transition={{ duration: 0.5, delay: 0.3 }}
              >
                <motion.h3
                  className="text-burgundy-500 font-bold text-xl mb-2"
                  whileHover={{ scale: 1.05, x: 8 }}
                  transition={{ type: "spring", stiffness: 300 }}
                >
                  데이팅 코치
                </motion.h3>
                <p className="text-stone-600 text-base leading-relaxed">
                  한번도 배워보지 못한 연애와 이성의 심리, 이제는 배움으로서 같은 시행착오를 겪지 않겠습니다.
                </p>
              </motion.div>
              
              <motion.div
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: false, amount: 0.5 }}
                transition={{ duration: 0.5, delay: 0.45 }}
              >
                <motion.h3
                  className="text-burgundy-500 font-bold text-xl mb-2"
                  whileHover={{ scale: 1.05, x: 8 }}
                  transition={{ type: "spring", stiffness: 300 }}
                >
                  글로벌 매칭 전문가
                </motion.h3>
                <p className="text-stone-600 text-base leading-relaxed">
                  전세계 한인싱글을 연결하는 글로벌 플렛폼 창업을 통해 여러분들의 인연을 찾아드리겠습니다.
                </p>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
